import { useGetCompanyReportPeriods } from '@shared/api/hooks/ccf/periods';
import { useGetActivityTypeUnits } from '@shared/api/hooks/ccf/units';
import InputFormField from '@shared/components/form/input-form-field';
import SelectFormField from '@shared/components/form/select-form-field';
import { RepeatableRowComponentProps } from '@shared/components/form/types';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useCCF } from '../../../ccf-context';
import { useGetPeriodOptions, useUnitOptions } from '../../../utils';
import { BUSINESS_TRAVEL_METHODOLOGY } from './constants';

interface BusinessTravelRecordsRowProps extends RepeatableRowComponentProps {}

export default function BusinessTravelRecordsRow({
  index,
  setDisableAdd,
  name,
}: BusinessTravelRecordsRowProps) {
  const { uuid: reportUuid } = useCCF();
  const { watch } = useFormContext();
  const methodology = watch('methodology');
  const site = watch('site');
  const fuel = watch('fuel');
  const passengerTransportMode = watch('passengerTransportMode');

  const unitsParams =
    methodology === BUSINESS_TRAVEL_METHODOLOGY.fuelUsage
      ? { site, fuel }
      : { site, passenger_transport_mode: passengerTransportMode };

  const { data: periodOptions } = useGetCompanyReportPeriods(reportUuid!);
  const { data: units } = useGetActivityTypeUnits(
    'business-travel',
    unitsParams,
    { enabled: !!fuel || !!passengerTransportMode }
  );

  useEffect(() => {
    setDisableAdd(true);
  });

  const recordsName = name ?? 'records';

  return (
    <div className="grid grid-cols-12 items-start gap-2">
      <SelectFormField
        name={`${recordsName}.${index}.timePeriod`}
        options={useGetPeriodOptions(periodOptions!)}
        disabled
        label={index === 0 ? 'Period' : ''}
        className="col-span-4"
      />
      <InputFormField
        name={`${recordsName}.${index}.quantity`}
        label={index === 0 ? 'Quantity' : ''}
        className="col-span-4"
        type="number"
        includeErrorMessage
      />
      <SelectFormField
        name="unit"
        options={useUnitOptions(units!)}
        label={index === 0 ? 'Unit' : ''}
        className="col-span-4"
        useShortLabel
        disabled
      />
    </div>
  );
}
